export default "__VITE_ASSET__CoHE$Q01__"